<div class="align-middle">
  <hr>
  <h6 class="text-uppercase">
    <span class="collapsible-text" (click)="goalToggle()">{{ ( (caseId !==
      undefined) ? 'CASE-GOALS' : 'PATIENT-GOALS') | translate:patientLabel}}</span>
    <app-collapsible #patientGoalCollapsible *ngIf="memberId !== undefined && caseId === undefined" [storageKey]="'patient-goal-member'"
      (collapsibleToggle)="patientGoalCollapsed=$event">
    </app-collapsible>
    <app-collapsible #caseGoalCollapsible *ngIf="caseId !== undefined" [storageKey]="'case-goal-member'"
    (collapsibleToggle)="caseGoalCollapsed=$event">
  </app-collapsible>    
    <div class="d-inline-block text-left float-right" style="position:relative;top:-10px;" placement="bottom-right">
      <button *ngIf="!patientGoalCollapsed && !caseGoalCollapsed" class="btn btn-outline-primary k-text-uppercase mr-2 pt-2" id="dropdownAdd"
        (click)="addGoal()">
        {{'ADD' | translate}}
      </button>
    </div>
  </h6>
</div>
<div *ngIf="!patientGoalCollapsed && !caseGoalCollapsed">
  <div *ngIf="goals.length === 0 ">
    <div class="row" style="color: rgba(0, 0, 0, 0.6);">
      <div class="col-12 p-0">
        <span>{{ 'NO-GOAL' | translate}}</span>
      </div>
    </div>
  </div>
  <div class="card mb-1 w-100" *ngFor="let goal of goals">
    <div class="card-body">
      <div class="row">
        <div class="col-11">
          <h6>{{goal.goal}}
            <span style="display: inline-flex" *ngIf="goal.createdBy">
              <div #goalTooltip kendoTooltip position="top" [tooltipTemplate]="goalTimestampTemplate" class="keyboard-accessible"
                tabindex="0" showOn="none" (focus)="showTooltip(goalsTooltip, goalTooltip)" (mouseover)="showTooltip(goalsTooltip, goalTooltip)"
                (blur)="hideTooltip(goalTooltip)" (mouseout)="hideTooltip(goalTooltip)" aria-live="polite">
                <i #goalsTooltip title="" class="fa fa-info-circle pointer"></i>
                <ng-template #goalTimestampTemplate>
                  <span>
                    {{'ADDED-BY-TIMESTAMP' | translate}}&nbsp;
                    <strong>{{goal.createdBy}}</strong>&nbsp;
                    {{'TIMESTAMP-ON' |
                    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(goal.createdOn),'g')}}</strong>
                  </span>
                  <br />
                  <span>
                    {{'UPDATED-BY-TIMESTAMP' | translate}}&nbsp;
                    <strong>{{goal.lastModifiedBy}}</strong>&nbsp;
                    {{'TIMESTAMP-ON' |
                    translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(goal.lastModifiedOn),'g')}}</strong>
                  </span>
                </ng-template>
              </div>
            </span>
          </h6>
        </div>
        <div class="col-1 my-auto text-right p-0">
          <i class="fas fa-edit fa-lg edit-icon mr-1" title="{{'EDIT' | translate}}"
            (click)="openGoalEditDialog(goal)"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-11 text-left text-secondary small">
          <span>{{goal.type.displayName}} | {{goal.progress.displayName}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Detailed info about team member selected -->
<app-goal-edit [model]="editDataItemGoal" [isNew]="isNewGoal" [memberId]="memberId" [caseId]="caseId" (save)="onSaveGoal($event)"
  (delete)="onDeleteGoal($event)">
</app-goal-edit>